import PartCardLoading from './PartCardLoading';

export default PartCardLoading;
